// Dynamically set the browser tab favicon. Falls back to the default when url is empty.
const DEFAULT_FAVICON = '/favicon.ico';

export function setFavicon(url) {
  const href = url && url.trim() ? url.trim() : DEFAULT_FAVICON;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}
